(ns io.daskul.tutorial.webapp.shared.events
  "Shared events for global HTTP handling.

  Dispatches ::unauthorized on 401 responses — the auth layer registers
  the handler for this event (in auth/events) to perform logout."
  (:require
   [re-frame.core :as rf]))

;; HTTP success: just forward to custom handler
(rf/reg-event-fx
 ::http-success
 (fn [_ [_ custom-event response]]
   {:dispatch (conj custom-event response)}))

;; HTTP failure: handle 401 with generic unauthorized event, forward others
(rf/reg-event-fx
 ::http-failure
 (fn [_ [_ custom-event {:keys [status] :as error}]]
   (if (= status 401)
     {:dispatch [::unauthorized]}
     {:dispatch (conj custom-event error)})))
